import { AlertTriangle, Loader2, RefreshCw, WifiOff } from "lucide-react";
import { Button } from "@/components/ui/button";

export function PageLoading({ label = "Loading…" }: { label?: string }) {
  return (
    <div
      role="status"
      aria-label={label}
      className="flex flex-col items-center justify-center py-24 text-muted-foreground gap-3 animate-fade-in"
    >
      <Loader2
        className="h-7 w-7 animate-spin text-primary"
        aria-hidden="true"
      />
      <p className="text-sm">{label}</p>
    </div>
  );
}

interface PageErrorProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  variant?: "server" | "network" | "generic";
}

export function PageError({
  title,
  message,
  onRetry,
  variant = "generic",
}: PageErrorProps) {
  const Icon = variant === "network" ? WifiOff : AlertTriangle;
  const defaultTitle =
    variant === "network"
      ? "Connection problem"
      : variant === "server"
        ? "Something went wrong on our end"
        : "Couldn't load this page";
  return (
    <div
      role="alert"
      className="flex flex-col items-center justify-center text-center py-20 px-4 gap-4 animate-fade-in"
    >
      <div className="h-14 w-14 rounded-full bg-destructive/10 flex items-center justify-center">
        <Icon className="h-7 w-7 text-destructive" aria-hidden="true" />
      </div>
      <div className="space-y-1 max-w-md">
        <h2 className="text-lg font-bold text-foreground">
          {title || defaultTitle}
        </h2>
        <p className="text-sm text-muted-foreground">
          {message ||
            "Please check your connection and try again. If the problem persists the service may be temporarily unavailable."}
        </p>
      </div>
      {onRetry && (
        <Button onClick={onRetry} size="sm" className="gap-2">
          <RefreshCw className="h-4 w-4" /> Retry
        </Button>
      )}
    </div>
  );
}
